/**
 * Shared helper for emitting Shopify standard storefront events (AD-29).
 *
 * Apps listen for these events instead of parsing theme DOM or intercepting
 * `window.fetch`. Every commercial interaction in the theme dispatches its
 * standard event through `THCabina.events.dispatch`, never by repeating the
 * call inline.
 *
 * Also dispatches `shopify:page:view` once per page load, reading the template
 * name from `data-template` on the body element.
 */
(function () {
  'use strict';

  function dispatch(name, props, target) {
    var event = new CustomEvent(name, { bubbles: true });
    if (props) {
      Object.keys(props).forEach(function (key) {
        event[key] = props[key];
      });
    }
    (target || document).dispatchEvent(event);
    return event;
  }

  function onReady(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
    } else {
      callback();
    }
  }

  onReady(function () {
    var template = document.body ? document.body.getAttribute('data-template') : '';
    dispatch('shopify:page:view', {
      page: {
        template: template || 'page',
        title: document.title,
        url: window.location.href
      }
    });

    // View events declared in the DOM (e.g. shopify:product:view) as JSON.
    document.querySelectorAll('script[type="application/json"][data-event]').forEach(function (node) {
      try {
        dispatch(node.getAttribute('data-event'), JSON.parse(node.textContent));
      } catch (error) {}
    });
  });

  window.THCabina = window.THCabina || {};
  window.THCabina.events = { dispatch: dispatch };
})();
